import { render, staticRenderFns } from "./EditDomain.vue?vue&type=template&id=71e193e4&"
import script from "./EditDomain.vue?vue&type=script&lang=js&"
export * from "./EditDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports